import SignUp from './SignUp.component';

export default SignUp;
